import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Drop errors in development to avoid noise
      if (import.meta.env.DEV) return null;
      return event;
    },
  });
} else {
  console.warn('[Sentry] VITE_SENTRY_DSN not set — error monitoring disabled');
}

/**
 * Manually capture an error with optional context tags.
 * Safe to call even when Sentry is not initialised (no-ops gracefully).
 */
export function captureError(
  error: unknown,
  context?: { feature?: string; action?: string; [key: string]: string | undefined }
) {
  console.error('[captureError]', context?.feature ?? '', error);

  if (!dsn) return;

  Sentry.withScope((scope) => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        if (value) scope.setTag(key, value);
      });
    }
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
  });
}

export { Sentry };
